export const selectPredictors = (state) => state.predictors.all || [];
export const selectCurrentPredictor = (state) =>
  state.predictors?.current || {};
export const selectIsLoading = (state) => state.predictors.isLoading;
export const selectLastPredictor = (state) => state.predictors.last || null;
export const selectPredictorsCount = (state) => state.predictors.count || 0;
